/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : requestNewAddress.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Srinivas Grandhi (E528634)
*
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
*
* By           : H224423
* On           : 01 Apr, 2020
* Description  : Added Modification History. ASDS-2190 - New Address API error handling.
*
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
*******************************************************************************/
import API from './api';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { RequestNewAddressForm, RequestNewAddressAPIResp } from '../../../../types';
import { logError } from '../../../utils/console-utility';

class RequestNewAddressAPI {
    static async CallRequestNewAddressAPI(userId: string, params: RequestNewAddressForm): Promise<RequestNewAddressAPIResp> {
        const URL: string = `${CheckoutServiceURL.NEW_ADDRESS_REGISTRATION_URL}/${userId}/sfdc-cases`;
        const response: any = await API.post(URL, params).catch(error => {
            logError('Error fetching and parsing data', error);
            throw new Error(error);
            // not handling unauthorised user scenario,
            // as it will redirect the user without giving status on the previous action.
        });
        return response ? response.data : {};
    }
}
export default RequestNewAddressAPI;